import { domMadeVideoPlayer } from "./video-player.js"
import {
  pausePlayingVideos,
  clearPlayerTrackingArr,
} from "./video-player-state.js"

const { icons } = window.theme

export default function setupMediaLightbox(node) {
  const lightboxMedia = node.querySelectorAll(".lightbox-media")

  if (!lightboxMedia.length) return

  let mediaLightbox

  import(flu.chunks.photoswipe).then(({ PhotoSwipeLightbox, PhotoSwipe }) => {
    mediaLightbox = new PhotoSwipeLightbox({
      gallery: node,
      children: "a",
      showHideAnimationType: "zoom",
      pswpModule: PhotoSwipe,
      mainClass: "pswp--product-lightbox",
      bgOpacity: 1,
      arrowPrevSVG: icons.leftChevronWithStem,
      arrowNextSVG: icons.rightChevronWithStem,
      closeSVG: icons.close,
      zoomSVG: icons.zoom,
      preloadFirstSlide: true,
    })

    // Add ability to check for video present within lightbox
    mediaLightbox.addFilter("itemData", (itemData) => {
      const videoUrl = itemData.element.dataset.videoUrl

      if (videoUrl) {
        itemData.videoUrl = videoUrl
      }
      return itemData
    })

    mediaLightbox.on("contentLoad", (e) => {
      const { content } = e

      if (content.type === "video") {
        e.preventDefault()

        let {
          externalVideoHost,
          externalVideoId,
          showPoster,
          videoPoster,
          videoAspectRatio,
          isBackgroundVideo,
        } = content.data.element.dataset

        // Build photoswipe div in advance of iframeContainer being appended
        content.element = document.createElement("div")
        content.element.className = "pswp__video-container"

        // Build video container to append to photoswipe div
        const videoContainer = document.createElement("div")

        if (videoAspectRatio < 1) {
          // Additional class to account for portrait videos to override styling and prevent cropping.
          videoContainer.className =
            "lightbox-video__container mismatched-aspect-video"
        } else {
          videoContainer.className = "lightbox-video__container"
        }

        videoContainer.style.setProperty(
          "--video-aspect-ratio",
          videoAspectRatio,
        )

        let video

        isBackgroundVideo = isBackgroundVideo === "true"
        if (isBackgroundVideo) {
          video = document.createElement("video")
          video.playsInline = true
          video.controls = false
          video.autoplay = true
          video.muted = true
          video.src = content.data.videoUrl
        } else {
          if (
            externalVideoHost === "vimeo" ||
            externalVideoHost === "youtube"
          ) {
            // Build iframe for external videos
            video = document.createElement("iframe")
            video.setAttribute("allowfullscreen", "")
            video.id = `lightbox-video-${externalVideoId}`
            videoContainer.setAttribute("data-video-type", externalVideoHost)
          } else {
            // Build video element for Shopify videos
            video = document.createElement("video")
            video.playsInline = true
            video.controls = true
          }

          video.src = content.data.videoUrl
        }

        showPoster = showPoster === "true"
        if (showPoster && !isBackgroundVideo) {
          // Show poster and play button until clicked to play
          videoContainer.setAttribute("data-show-poster", true)

          if (externalVideoHost) {
            video.setAttribute("allow", "autoplay")
          }

          const posterTemplate = node.querySelector(
            "[js-lightbox-video-poster-container]",
          )
          const currentPoster = posterTemplate.content.cloneNode(true)
          videoContainer.appendChild(currentPoster)

          let posterImage

          if (videoPoster) {
            posterImage = videoContainer.querySelector(
              "[js-lightbox-video-poster]",
            )
            posterImage.src = videoPoster
          } else {
            posterImage = videoContainer.querySelector(".poster-placeholder")
          }
          // Append videoContainer with poster
          content.element.appendChild(videoContainer)
        } else {
          videoContainer.setAttribute("data-has-poster", false)
          content.element.appendChild(videoContainer)
        }

        domMadeVideoPlayer(videoContainer, video)
      }
    })

    mediaLightbox.on("afterInit", () => {
      const initSlideVideo = mediaLightbox.pswp.currSlide.data.type === "video"

      if (initSlideVideo) {
        const initialVideoPlayButton =
          mediaLightbox.pswp.currSlide.content.element.firstChild.childNodes[1]

        // Removes poster to reveal video when opening lightbox
        initialVideoPlayButton.click()
      }
    })

    mediaLightbox.init()

    if (window.Shopify?.designMode) {
      node.addEventListener("shopify:section:load", () => {
        // Re-init lightbox after theme editor re-render to allow it to keep working
        mediaLightbox.init()
      })
    }

    // Hide nav ui elements if single image
    mediaLightbox.on("firstUpdate", () => {
      const { pswp, options } = mediaLightbox
      const mediaCount = options.dataSource.items.length

      if (mediaCount === 1) {
        pswp.element.classList.add("pswp--is-single-image")
      }
    })

    // Remove video to stop playing and reset to poster
    mediaLightbox.on("contentDeactivate", ({ content }) => {
      if (content.type === "video") {
        pausePlayingVideos()
      }
    })

    mediaLightbox.on("close", () => {
      clearPlayerTrackingArr()
    })
  })
}
